import { render, staticRenderFns } from "./InventoryRequestDetail.vue?vue&type=template&id=70d40e3a&scoped=true&"
import script from "./InventoryRequestDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryRequestDetail.vue?vue&type=style&index=0&id=70d40e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d40e3a",
  null
  
)

export default component.exports